import script from "./DepartmentMissing.vue?vue&type=script&setup=true&lang=ts"
export * from "./DepartmentMissing.vue?vue&type=script&setup=true&lang=ts"

import "./DepartmentMissing.vue?vue&type=style&index=0&id=67b2966e&lang=scss"

const __exports__ = script;

export default __exports__